import { createGlobalStyle } from 'styled-components'

export const GlobalStyle = createGlobalStyle`
  :root {
    --white: #fff

    --blue-500: #121926;

    --gray-50: #EEEEEE;
    --gray-100: #D9E0ED;
    --gray-200: #B7B7B7;
    --gray-300: #A6A6A6
    --gray-400: #929292;
    --gray-500: #333333

    --gray-900: #0D0D0D;

    --black: #000;
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  @media (max-width: 1080px) {
    html {
      font-size: 93.75%;
    }
  }

  @media (max-width: 720px) {
    html {
      font-size: 87.5%;
    }
  }


  body {
    overflow-x: hidden;
    background: #fff;
    font-size: 14px;
    color: #333;
  }

  .ReactModal__Overlay {
    z-index: 2;
  }
`
